import { render, staticRenderFns } from "./TypeListView.vue?vue&type=template&id=537acaa0&scoped=true"
import script from "./TypeListView.vue?vue&type=script&lang=js"
export * from "./TypeListView.vue?vue&type=script&lang=js"
import style0 from "./TypeListView.vue?vue&type=style&index=0&id=537acaa0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537acaa0",
  null
  
)

export default component.exports